import { initAccordionAsaidMenu } from '../components/accordions/initAccordionAsaidMenu';
import { initAccordions } from '../components/initAccordions';

window.addEventListener('DOMContentLoaded', handleOnLoadPage, false);

function handleOnLoadPage() {
    initAccordionAsaidMenu();
    initAccordions();
}
